import { Extension } from '@tiptap/core';
import { MinimalMediaTarget } from 'Shared/FrameModules/MediaLibrary/minimal_target';
import { activateMediaManager } from 'Shared/FrameModules/MediaLibrary/media_manager_helpers';

declare module '@tiptap/core' {
   interface Commands<ReturnType> {
      mediaManager: {
         activateMediaManager: () => ReturnType;
      };
   }
}

export const MediaManager = Extension.create({
   name: 'mediaManager',

   addCommands() {
      return {
         activateMediaManager:
            () =>
            ({ commands }) => {
               commands.blur();
               const editor = this.editor;

               activateMediaManager('wiki_media').then(mediaItem => {
                  const imageContent = mediaItem.toWikiText();
                  editor.chain().focus().insertContent(imageContent).run();
               });
               return true;
            },
      };
   },
});
